module.exports = __webpack_public_path__ + "static/img/Peekaboo Baguette.260f234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Peekaboo Baguette.jpg
// module id = Dlut
// module chunks = 1